export default "__VITE_ASSET__BEK2e_sm__"